module.exports = __webpack_public_path__ + "static/media/virtual.d5fdab03.gif";